<script setup>
import { get, loadEpsgs, post, toJson } from '@/common/util'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive } from 'vue'
const metaStore=useMetaStore(),meta=reactive({})
,save=()=>{
  const confs=meta.right.epsgs.map(ep=>({wkey:'epsg',ival:ep}))
  if(confs.length==0)confs.push({wkey:'epsg',etc:'onlydelete'})
  metaStore.blockLoading()
  post('rest/authed/admin/resetconfs',confs,res=>{
    metaStore.blockLoading(false)
    metaStore.toastKey('thesaveiscomplete')
  })
},filter=key=>{
  meta[key].filterd=meta[key].epsgs.filter(ep=>ep.toString().startsWith(meta[key].searchval.toString()))
  sort('left')
},move=key=>{
  const fromkey=key=='left'?'right':'left'
  meta[fromkey].selected.forEach(ep=>meta[key].epsgs.push(ep))
  meta[fromkey].epsgs=meta[fromkey].epsgs.filter(ep=>!meta[fromkey].selected.includes(ep))
  meta[fromkey].selected=[]
  filter(key)
  filter(fromkey)
},init=()=>{
  clear()
  metaStore.blockLoading()
  loadEpsgs(epsgs=>{
    meta.right.epsgs=epsgs
    meta.right.filterd=toJson(epsgs)
    get('rest/authed/member/epsgs',res=>{
      meta.left.epsgs=res.data
      meta.left.epsgs=meta.left.epsgs.filter(ep=>!meta.right.epsgs.includes(ep))
      filter('left')
      sort('left')
      metaStore.blockLoading(false)
    })
  })
},clear=()=>{
  meta.left.searchval=''
  meta.right.searchval=''
  meta.left.selected=[]
  meta.right.selected=[]
},sort=key=>{
  meta[key].filterd.sort((a, b) => a - b)
}
new Array('left','right').forEach(key=>meta[key]={epsgs:[],selected:[],filterd:[],searchval:''})
init()
</script>
<template>
  <v-card flat>
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="10" class="text-subtitle-1">
          {{ $t('setcoordinatesystem') }}
        </v-col>
        <v-col cols="2" class="text-end">
          <v-btn class="me-5" @click="init">{{ $t('refresh') }}</v-btn>
          <v-btn color="primary" @click="save">{{ $t('save') }}</v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card class="text-caption pa-2 ma-4 bg-grey-lighten-4">
      <div>{{ $t('checkitout') }}</div>
      <div>{{ $t('setupyourfavoritecoordinatesystem') }}</div>
      <div>{{ $t('youcanadddeleteanycoordinatesystemyouwantatanytime') }}</div>
    </v-card>
    <v-card-text>
      <v-row>
        <template v-for="key in ['left','cen','right']">
          <v-col v-if="key!='cen'">
            <v-card>
              <v-text-field prepend-inner-icon="mdi-magnify" :label="$t('search')" v-model="meta[key].searchval" @update:model-value="filter(key)"/>
              <v-list height="calc(100vh - 500px)" v-model:selected="meta[key].selected" lines="one" select-strategy="leaf">
                <v-list-item v-for="item in meta[key].filterd" :key="item" :title="'EPSG:'+item" :value="item"/>
              </v-list>
            </v-card>
          </v-col>
          <v-col v-else cols="1" class="d-flex flex-column align-center justify-center">
            <v-btn prepend-icon="mdi-chevron-left" :text="$t('move')" class="mb-5" @click="move('left')"/>
            <v-btn append-icon="mdi-chevron-right" :text="$t('move')" @click="move('right')"/>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>
